import React, { Component } from 'react';
import Proptypes from 'prop-types';
import { Modal, FormGroup, FormControl, ControlLabel, HelpBlock } from 'react-bootstrap';

import './DialogRequestAppointment.css';

import DropdownMenu from '../../../Components/DropdownMenu';
import Loader from 'dataphi-react-components/dist/Containers/DataphiLoader/Component/LoaderComponent';



class DialogRequestAppointment extends Component {

    constructor(props) {
        super(props);

        this.state = {
            countryList: [],
            stateList: [],
            cityList: [],
            partnersList: [],
            specialityList: [],

            selectedCountry: 0,
            selectedState: 0,
            selectedCity: 0,
            selectedPartner: 0,
            selectedSpeciality: 0,
            additionalRequest: '',

            showError: false,
            showSuccess: false
        };

        this.eventChangeCountry = this.eventChangeCountry.bind(this);
        this.eventChangeState = this.eventChangeState.bind(this);
        this.eventChangeCity = this.eventChangeCity.bind(this);
        this.eventChangePartner = this.eventChangePartner.bind(this);
        this.eventChangeSpeciality = this.eventChangeSpeciality.bind(this);
        this.eventChangeRequestText = this.eventChangeRequestText.bind(this);
    }


    // Lifecycle Methods

    render() {
        const { state, props } = this;

        const partner = Boolean(state.partnersList.length) && state.partnersList[state.selectedPartner].name;

        return (
        <Modal show={this.props.open} onHide={this.props.onClose}>

            <Modal.Header closeButton>
                <Modal.Title><span className="hsg-dra-title-text">REQUEST APPOINTMENT</span></Modal.Title>
            </Modal.Header>


            {!state.showSuccess ?
            <Modal.Body style={{margin: '0 20px 20px'}}>

                <p className="hsg-dra-body-text">We thank you for taking the next step with regards to your child's Health.<br />Please fill in the required details below and we will forward your request to our Medical Partner.</p>


                <DropdownMenu
                    label="COUNTRY"
                    value={state.countryList[state.selectedCountry] || ''}
                    optionList={this.state.countryList}
                    onChange={this.eventChangeCountry}
                    isLoading={this.props.countryList.isLoading} />

                
                <DropdownMenu
                    label="STATE"
                    value={state.stateList[state.selectedState] || ''}
                    optionList={this.state.stateList}
                    onChange={this.eventChangeState}
                    disabled={!this.props.stateList.loaded}
                    isLoading={this.props.stateList.isLoading} />

                
                <DropdownMenu
                    label="CITY"
                    value={state.cityList[state.selectedCity] || ''}
                    optionList={this.state.cityList}
                    onChange={this.eventChangeCity}
                    disabled={!this.props.cityList.loaded}
                    isLoading={this.props.cityList.isLoading} />

                
                <DropdownMenu
                    label="MEDICAL PARTNER"
                    value={partner || ''}
                    optionList={this.state.partnersList.map((item) => item.name)}
                    onChange={this.eventChangePartner}
                    isLoading={this.props.partnersList.isLoading} />

                
                <DropdownMenu
                    label="SPECIALITY"
                    value={state.specialityList[state.selectedSpeciality] || ''}
                    optionList={this.state.specialityList}
                    onChange={this.eventChangeSpeciality}
                    isLoading={this.props.specialityList.isLoading} />


                <div style={{height: 30}} />


                <FormGroup controlId="dialog-request-appointment">

                    <ControlLabel>ADDITIONAL REQUESTS</ControlLabel>

                    <HelpBlock>Please enter any Additional Requests here</HelpBlock>

                    <FormControl
                        componentClass="textarea"
                        value={this.state.additionalRequest}
                        onChange={this.eventChangeRequestText}
                        style={{height: 100}} />

                </FormGroup>


                {this.props.dialogState.isPosting ?
                    <div style={{padding: 20}}><Loader /></div>
                    
                :

                    <div style={{textAlign: 'end'}}>
                        <span className="hsg-dra-button-submit" onClick={() => this.onSubmit()}>
                            SUBMIT
                        </span>

                        {state.showError && <div style={{marginTop: 10}}>{this.props.dialogState.error}</div>}
                    </div>}
                
            </Modal.Body>
            
            :
            
            <Modal.Body>
                <p className="hsg-dte-subtitle-text">Your Request was posted Successfully</p>
            </Modal.Body>}

        </Modal>);
    }


    componentDidMount() {
        const newState = {};

        if(!this.props.countryList.loaded) this.props.fetchCountryList();
        else {
            newState.countryList = this.buildCountryList(this.props.countryList.data);

            if(Boolean(this.props.child) && Boolean(this.props.child.schoolCountry)) {
                newState.selectedCountry = this.getSelectedLoc(this.props.countryList.data, this.props.child.schoolCountry);
            }
            else {
                newState.selectedCountry = 0;
            }

            this.props.fetchStateList(this.props.countryList.data[newState.selectedCountry].id);
        }

        if(!this.props.partnersList.loaded) this.props.fetchPartnerList();
        else {
            newState.partnersList = this.buildPartnersList(this.props.partnersList.data, this.props.cityList.data[this.state.selectedCity]);
        }

        if(!this.props.specialityList.loaded) this.props.fetchSpecialityList();
        else {
            newState.specialityList = this.buildSpecialityList(this.props.specialityList.data);
        }

        
        this.setState(newState);

        this.props.resetStoreState();
    }


    componentWillReceiveProps(newProps) {
        const newState = {};

        if(!newProps.countryList.isLoading && this.props.countryList.isLoading && newProps.countryList.loaded) {
            newState.countryList = this.buildCountryList(newProps.countryList.data);

            if(Boolean(newProps.child.schoolCountry)) {
                newState.selectedCountry = this.getSelectedLoc(newProps.countryList.data, newProps.child.schoolCountry);
            }

            else {
                newState.selectedCountry = 0;
            }

            this.props.fetchStateList(newProps.countryList.data[newState.selectedCountry].id);
        }

        if(!newProps.stateList.isLoading && this.props.stateList.isLoading && newProps.stateList.loaded) {
            newState.stateList = this.buildStateList(newProps.stateList.data);

            if(Boolean(newProps.child.schoolState)) {
                newState.selectedState = this.getSelectedLoc(newProps.stateList.data, newProps.child.schoolState);
            }

            else {
                newState.selectedState = 0;
            }

            this.props.fetchCityList(newProps.stateList.data[newState.selectedState].id);
        }

        if(!newProps.cityList.isLoading && this.props.cityList.isLoading && newProps.cityList.loaded) {
            newState.cityList = this.buildCityList(newProps.cityList.data);

            if(Boolean(newProps.child.schoolCity)) {
                newState.selectedCity = this.getSelectedLoc(newProps.cityList.data, newProps.child.schoolCity);
            }

            else {
                newState.selectedCity = 0;
            }

            newState.partnersList = this.buildPartnersList(newProps.partnersList.data, newProps.cityList.data[newState.selectedCity]);
            newState.selectedPartner = 0;
        }

        if(!newProps.partnersList.isLoading && this.props.partnersList.isLoading && newProps.partnersList.loaded) {
            newState.partnersList = this.buildPartnersList(newProps.partnersList.data, newProps.cityList.data[newState.selectedCity || this.state.selectedCity]);
            newState.selectedPartner = 0;
        }

        if(!newProps.specialityList.isLoading && this.props.specialityList.isLoading && newProps.specialityList.loaded) {
            newState.specialityList = this.buildSpecialityList(newProps.specialityList.data);
        }


        if(!newProps.dialogState.isPosting && this.props.dialogState.isPosting) {
            if(newProps.dialogState.status) {
                this.setState({showSuccess: true});
            }

            else {
                this.setState({showError: true});
            }
        }


        this.setState(newState);
    }


    // Event Listeners

    eventChangeCountry(e) {
        const selectedCountry = findArrayIndex(this.state.countryList, (item) => item === e.target.value);//this.state.countryList.findIndex((item) => item === e.target.value);
        this.setState({selectedCountry});

        this.props.fetchStateList(this.props.countryList.data[selectedCountry].id);
    }

    eventChangeState(e) {
        const selectedState = findArrayIndex(this.state.stateList, (item) => item === e.target.value);//this.state.stateList.findIndex((item) => item === e.target.value);
        this.setState({selectedState});

        this.props.fetchCityList(this.props.stateList.data[selectedState].id);
    }

    eventChangeCity(e) {
        const newState = {
            selectedCity: findArrayIndex(this.state.cityList, (item) => item === e.target.value),
            selectedPartner: 0
        };

        newState.partnersList = this.buildPartnersList(this.props.partnersList.data, this.props.cityList.data[newState.selectedCity]);
        
        this.setState(newState);
    }

    eventChangePartner(e) {
        this.setState({selectedPartner: findArrayIndex(this.state.partnersList, (item) => item.name === e.target.value)/*this.state.partnersList.findIndex((item) => item === e.target.value)*/});
    }

    eventChangeSpeciality(e) {
        this.setState({selectedSpeciality: findArrayIndex(this.state.specialityList, (item) => item === e.target.value)/*this.state.specialityList.findIndex((item) => item === e.target.value)*/});
    }

    eventChangeRequestText(e) {
        this.setState({additionalRequest: e.target.value});
    }


    onSubmit() {
        if(Boolean(this.state.countryList) &&
        Boolean(this.state.stateList) &&
        Boolean(this.state.cityList) &&
        Boolean(this.state.partnersList) &&
        Boolean(this.state.specialityList)) {
            const props = this.props;

            const params = {
                parentId: props.user.uuId,
                studentId: props.child.uuId,
                country: props.countryList.data[this.state.selectedCountry].id,
                state: props.stateList.data[this.state.selectedState].id,
                district: props.cityList.data[this.state.selectedCity].id,
                partner: this.state.partnersList[this.state.selectedPartner].id,
                speciality: props.specialityList.data[this.state.selectedSpeciality].id,
                additionalRequest: this.state.additionalRequest
            };

            this.props.postAppointmentRequest(params);
        }
    }


    // Other Methods

    buildCountryList(list) {
        return list.map((item) => item.country_name);
    }

    buildStateList(list) {
        return list.map((item) => item.state_desc);
    }

    buildCityList(list) {
        return list.map((item) => item.city_name);
    }

    buildPartnersList(list, city) {
        const result = [];

        list.forEach((item) => {
            if(!Boolean(city) || item.organization_district == city.id) {
                result.push({
                    id: item.id,
                    name: item.organization_name
                });
            }
        });

        return result;
    }

    buildSpecialityList(list) {
        return list.map((item) => item.speciality_name);
    }


    getSelectedLoc(list, id) {
        const index = findArrayIndex(list, (item) => item.id === id);//list.findIndex((item) => item.id === id);
        return index > -1 ? index : 0;
    }

}



DialogRequestAppointment.propTypes = {
    open: Proptypes.bool.isRequired,
    onClose: Proptypes.func.isRequired
};



var findArrayIndex = function (array, predicateFunction) {
    var length = array == null ? 0 : array.length;
    if (!length) {
        return -1;
    }
    var index = -1;
    for (var i = 0; i < array.length; ++i) {
        if(predicateFunction(array[i])) {
            index = i;
            break;
        }
    }
    return index;
}



export default DialogRequestAppointment